import React from 'react';
import classnames from 'classnames';
import classes from './info-size.scss';
export default function InfoSize(props) {
  const {
    logoSize: {
      width,
      height
    },
    className
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.infoContainer, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Design Size:"), /*#__PURE__*/React.createElement("div", {
    className: classes.size
  }, width.toFixed(2), "in \u2715 ", height.toFixed(2), "in"));
}